import { createAction } from 'typesafe-actions';
import { ACTIONS, RoundStates } from './types';

export const changeRoundStateAction = createAction(ACTIONS.CHANGE_ROUND_STATE)<{
  roundState: RoundStates;
}>();
